module.exports = __webpack_public_path__ + "static/media/05.2cb7711f.mp3";